var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgX = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "m10.245 7.957 4.883-5.272h-1.182l-4.23 4.567L6.3 2.682H2.284l5.212 6.967-5.246 5.666h1.181l4.594-4.961 3.709 4.961h4.016l-5.505-7.361zM4.02 3.551h1.845l8.149 10.898h-1.845z" }) }))); };
export default SvgX;
